
import config from 'local_config';
import Footer from 'app/components/FooterComponent';
import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { connect } from 'react-redux';
import { REMOVE_APP_ERROR } from 'actionsConstants';
import { DEBUG } from 'debug';

type State = {
  showGears: boolean,
};

type Props = {
  error: { info: string, stack: string, isIE: boolean } | null,
  dispatch: Function,
};

class ErrorPageModal extends React.Component<Props, State> {
  state = {
    showGears: false,
  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({ showGears: true });
    },         1000);
  }

  renderGears = (isIE: boolean) => {
    const { showGears } = this.state;
    return (
      <div className={showGears ? '' : 'loading'}>
        <h1>Oops</h1>
        <h2 className="info">
          {isIE ? this.renderIEMessage() : this.renderStandardMessage()}
        </h2>
        <div className="gears">
          <div className="gear one">
            <div className="bar" />
            <div className="bar" />
            <div className="bar" />
          </div>
          <div className="gear two">
            <div className="bar" />
            <div className="bar" />
            <div className="bar" />
          </div>
          <div className="gear three">
            <div className="bar" />
            <div className="bar" />
            <div className="bar" />
          </div>
        </div>
      </div>
    );
  }

  renderStack = () => {
    const { error } = this.props;

    if (error === null) {
      return null;
    }

    return (
      <div className="error-stack">
        {error.info && <div className="component-stack-trace">
          <pre>{error.info.trim()}</pre>
        </div>}
        {error.stack && <div className="stack-trace">
          <div>
            <pre>{error.stack.trim()}</pre>
          </div>
        </div>}
      </div>
    );
  }

  renderStandardMessage = () => {
    return (
      <>
        <h2>
          Unexpected Error <b> :( </b>
        </h2>
        <h2 className="info">
          We apologize for the inconvenience.  Please use the Report Issues button below to report this error.
        </h2>
      </>
    );
  }

  renderIEMessage = () => {
    return (
      <h2 className="info">
        This application does not support Internet Explorer. For best results please use Chrome, Edge, Opera, or Safari
      </h2>
    );
  }

  isIE = () => {
    return this.props.error && this.props.error.isIE;
  }

  render() {
    const { error, dispatch } = this.props;
    const isProd = config.isProd;
    const isIE = this.isIE();
    
    if (!DEBUG.showPageErrorModal) {
      return null;
    }

    return (
      <Dialog
        // id="error-page-modal"
        // open={error !== null}
        // title={'Oooppsss...'}
        // fullPage={true}
        // focusOnMount={false}
        open={error !== null}
        fullScreen={true}
        onClose={() => dispatch(REMOVE_APP_ERROR())}
        aria-labelledby="error-page-modal-title"
        aria-describedby="error-page-modal-description"
        className={`error-page-modal ${isProd || isIE ? 'error-page-modal-production' : 'error-page-modal-development'}`}
        disableEscapeKeyDown={true}
      >
        <div className={`error-page ${isProd || isIE ? 'error-page-production' : 'error-page-development'}`}>
          {/* <Button icon={true} color="primary" onClick={() => dispatch(REMOVE_APP_ERROR())}>close</Button> */}
          { <Button variant="contained" color="secondary" onClick={() => dispatch(REMOVE_APP_ERROR())}>Close</Button> }
          {this.renderGears(isIE)}
          {!isProd && !isIE && this.renderStack()}
          <Footer />
        </div>
      </Dialog>

    );
  }
}

function mapStateToProps(state: appState) {
  return {
    error: state.router.error,
  };
}

export default connect(mapStateToProps)(ErrorPageModal);

